module.exports = __webpack_public_path__ + "f0ffcb97b13b3222b72b0e84d716009e.png";